import queryString from 'query-string'
import omit from 'lodash.omit'

export const queryStringToObject = (str, options = {}) =>
  queryString.parse(str, {
    arrayFormat: 'bracket',
    ...options,
  })

export const objectToQueryString = (obj, options = {}) =>
  queryString.stringify(obj, {
    arrayFormat: 'bracket',
    ...options,
  })

export const omitFromQueryString = (str, keys) =>
  objectToQueryString(omit(queryStringToObject(str), keys))

export const addToQueryString = (str, fields) =>
  objectToQueryString({
    ...queryStringToObject(str),
    ...fields,
  })

export const buildUpdatedReturnUri = (old_url, currentPage) => {
  if (!old_url) {
    return undefined
  }
  let auth_url = new URL(old_url)
  let searchParams = auth_url.searchParams
  searchParams.set('returnUri', currentPage)
  auth_url.search = searchParams.toString()
  auth_url = auth_url.toString()

  return auth_url
}

export const buildSwitchUserUrl = (old_url, currentPage) => {
  if (!old_url) {
    return undefined
  }
  let switch_user_url = new URL(old_url)
  let switch_user_search_params = switch_user_url.searchParams

  let relogin_url = new URL(switch_user_search_params.get('returnUri'))
  let relogin_url_search_params = relogin_url.searchParams

  let return_uri_after_relogin = new URL(
    relogin_url_search_params.get('returnUri'),
  )
  let new_return_uri_after_relogin = new URL(
    currentPage + return_uri_after_relogin.search,
  )

  relogin_url_search_params.set('returnUri', new_return_uri_after_relogin)
  relogin_url.search = relogin_url_search_params.toString()
  relogin_url = relogin_url.toString()

  switch_user_search_params.set('returnUri', relogin_url)
  switch_user_url.search = switch_user_search_params.toString()
  switch_user_url = switch_user_url.toString()

  return switch_user_url
}
